export default "__VITE_ASSET__C2KCr4H6__"